import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import { NewInvoicePage } from '@/features/collections';

export const Route = createFileRoute('/_app/collections/invoices/new')({
  staticData: { crumb: 'collections:invoices.create.title' },
  beforeLoad: ({ context }) =>
    requirePermission(context.queryClient, 'collection.manage', 'Collections'),
  component: function NewInvoice() {
    const search = Route.useSearch();
    return <NewInvoicePage period={search.period} bank={search.bank} />;
  },
});
